import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveWiggle16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconMoveWiggle16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M3.877 5.257c.036.797-.392 1.363-.674 1.75-.314.43-.48.68-.478 1.011.001.327.168.578.48 1.008.28.385.703.948.672 1.732-.025.632-.33 1.32-.578 1.791a9 9 0 0 1-.507.848l-.01.014-.003.004v.002a.6.6 0 0 1-.984-.687v-.002l.007-.009a4 4 0 0 0 .126-.193c.084-.133.196-.321.308-.535.239-.454.428-.936.442-1.28.012-.314-.137-.558-.444-.98-.273-.376-.704-.933-.709-1.706-.004-.786.432-1.347.708-1.726.309-.422.46-.666.446-.987-.016-.346-.208-.835-.447-1.296a9 9 0 0 0-.407-.7l-.027-.041-.006-.01v-.002l-.001.001a.6.6 0 0 1 .991-.677l.001.002q0 .003.003.004l.01.015.034.05q.044.067.116.184c.095.155.223.372.353.622.246.476.55 1.167.578 1.793m7.022 2.744A2.899 2.899 0 1 1 5.102 8a2.899 2.899 0 0 1 5.797 0M9.7 8a1.698 1.698 0 1 0-3.396 0A1.698 1.698 0 0 0 9.7 8m4.775.025c-.005.773-.436 1.33-.71 1.706-.306.422-.455.666-.443.98.014.344.204.826.442 1.28a8 8 0 0 0 .434.728l.006.01.001.001a.6.6 0 1 1-.983.688v-.001l-.001-.002-.003-.004-.01-.014-.034-.05-.117-.182a9 9 0 0 1-.356-.616c-.247-.471-.553-1.159-.578-1.79-.03-.785.393-1.348.672-1.733.312-.43.479-.681.48-1.008.002-.332-.164-.582-.478-1.012-.282-.386-.71-.952-.674-1.749.029-.626.332-1.317.578-1.793a10 10 0 0 1 .469-.805l.034-.051.01-.015.003-.004v-.002a.6.6 0 0 1 .992.677h-.001v.001l-.006.01-.027.04-.1.157a9 9 0 0 0-.307.544c-.239.46-.43.95-.447 1.296-.014.321.137.565.446.987.276.38.712.94.708 1.726"
            />
        </svg>
    );
}
export default memo(IconMoveWiggle16);
